import React, { PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'
import { Button } from '../../../../components/Button'
import { messages as buttonMessages } from '../../../../components/Button/messages'
import { BigButtonContent } from '../../../../components/layout'
import { Styling } from '../../../../components/Styling'

interface SaveButtonProps {
  onClick: () => void
}

export const SaveButton: React.FC<PropsWithChildren<SaveButtonProps>> = ({ children, onClick }) => {
  const { formatMessage } = useIntl()
  return (
    <Button category="save" onClick={onClick} size="l" padding="0 4rem">
      <BigButtonContent>{children ? children : <Styling fontSize="m">{formatMessage(buttonMessages.save)}</Styling>}</BigButtonContent>
    </Button>
  )
}
